(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('FollowupType', FollowupType);

    FollowupType.$inject = ['$resource'];

    function FollowupType ($resource) {
        var resourceUrl =  'api/followup-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
